import { Component, computed, input, output } from '@angular/core';

@Component({
  selector: 'app-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrl: './icon-button.component.scss',
})
export class IconButtonComponent {
  icon = input.required();
  size = input<number>(16);
  sizePx = computed(() => {
    return this.size() + 'px';
  });
  label = input<string>();
  disabled = input<boolean>(false);
  textColor = input<string>('text-primary-600');

  handleClick = output<MouseEvent>();

  onClick(event: MouseEvent) {
    this.handleClick.emit(event);
  }
}
